(function () {
  try {
    // ✅ SOLO en landings marcadas
    if (!document.querySelector('[data-ads-landing="true"]')) return;

    var redirected = false;
    var lastCount = null;
    var pendingCheck = false;

    function goCart() {
      if (redirected) return;
      redirected = true;
      window.location.assign('/cart');
    }

    function getCartCount() {
      // cache-buster para evitar lecturas cacheadas
      return fetch('/cart.js?ts=' + Date.now(), { credentials: 'same-origin' })
        .then(function (r) { return r.json(); })
        .then(function (c) { return (c && typeof c.item_count === 'number') ? c.item_count : null; })
        .catch(function () { return null; });
    }

    // Guardar conteo inicial
    function initCount() {
      getCartCount().then(function (c) { lastCount = c; });
    }

    // ✅ Check real: si el carrito SUBIÓ => redirige
    function redirectIfCartIncreased() {
      // Evita disparar 5 checks seguidos si el tema hace muchas llamadas
      if (pendingCheck) return;
      pendingCheck = true;

      // Si no tenemos baseline, la tomamos primero
      var baselinePromise = (lastCount === null)
        ? getCartCount().then(function (c) { lastCount = c; return c; })
        : Promise.resolve(lastCount);

      baselinePromise.then(function (before) {
        if (before === null) { pendingCheck = false; return; }

        // Espera corta para que Debutify termine de actualizar el carrito
        setTimeout(function () {
          getCartCount().then(function (after) {
            pendingCheck = false;
            if (after === null) return;

            // Actualiza baseline siempre
            if (after > lastCount) lastCount = after;

            // ✅ Solo redirige si subió vs "before"
            if (after > before) goCart();
          });
        }, 350);
      });
    }

    function isCartAddUrl(url) {
      return typeof url === 'string' && (
        url.indexOf('/cart/add') !== -1 || url.indexOf('/cart/add.js') !== -1
      );
    }

    // -----------------------------
    // 1) Hook FETCH (Add to cart via fetch)
    // -----------------------------
    if (typeof window.fetch === 'function') {
      var originalFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var req = args[0];
        var url = '';

        try {
          url = (typeof req === 'string') ? req : (req && req.url) ? req.url : '';
        } catch (e) {}

        return originalFetch.apply(this, args).then(function (res) {
          try {
            if (isCartAddUrl(url) && res && res.ok) {
              redirectIfCartIncreased();
            }
          } catch (e) {}
          return res;
        });
      };
    }

    // -----------------------------
    // 2) Hook XHR (Add to cart via XHR)
    // -----------------------------
    var open = XMLHttpRequest.prototype.open;
    var send = XMLHttpRequest.prototype.send;

    XMLHttpRequest.prototype.open = function (method, url) {
      this.__isCartAdd = isCartAddUrl(url);
      return open.apply(this, arguments);
    };

    XMLHttpRequest.prototype.send = function () {
      if (this.__isCartAdd) {
        this.addEventListener('load', function () {
          try {
            if (this.status >= 200 && this.status < 300) {
              redirectIfCartIncreased();
            }
          } catch (e) {}
        });
      }
      return send.apply(this, arguments);
    };

    // -----------------------------
    // 3) Escuchar EVENTOS del tema (clave para el botón fijo)
    // -----------------------------
    var eventsToCatch = [
      'theme:cart:added',
      'theme:cart:updated',
      'cart:added',
      'cart:updated',
      'ajaxCart:added',
      'ajaxCart:updated',
      'dbtfy:cart:added',
      'dbtfy:cart:updated'
    ];

    eventsToCatch.forEach(function (evt) {
      document.addEventListener(evt, function () {
        // No asumimos que aumentó; lo verificamos
        redirectIfCartIncreased();
      }, true);
    });

    // -----------------------------
    // 4) BONUS: Si el botón fijo usa submit de form normal
    // -----------------------------
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form || !form.action) return;
      if (form.action.indexOf('/cart/add') === -1) return;

      // Si hay submit normal, esperamos a que Shopify responda y verificamos
      setTimeout(redirectIfCartIncreased, 200);
    }, true);

    // baseline al cargar
    initCount();

  } catch (e) {
    // silencioso
  }
})();
